module.exports = __webpack_public_path__ + "img/title1.2247a90e.png";